import { render } from "./Question.vue?vue&type=template&id=4e4ff685&scoped=true"
import script from "./Question.vue?vue&type=script&lang=ts"
export * from "./Question.vue?vue&type=script&lang=ts"

import "./Question.vue?vue&type=style&index=0&id=4e4ff685&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e4ff685"

export default script